import { createSelector } from '@reduxjs/toolkit'
import { CredentialsGroupsBody } from 'redux/reducers/CredentialsGroups'

import { ApplicationState } from 'redux/Stores/types'

// select all credentials groups
export const selectAll = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.CredentialsGroupsStore.data,
    (state: ApplicationState) => state.CredentialsGroupsStore.fetched
  ],
  (data, fetched): [CredentialsGroupsBody, boolean] => [data, fetched]
)
